import { createRouter, createWebHistory } from 'vue-router'

import HomepageView from '@/views/HomepageView.vue'
import ErrorView from '@/views/ErrorView'
import GdprView from '@/views/GdprView'
import FaqView from '@/views/FaqView'
import AboutUsView from '@/views/AboutUsView'
import ConstructionView from '@/views/ConstructionView'
import ForestryLandView from '@/views/ForestryLandView'
import ComplianceView from '@/views/ComplianceView'
import ContactUsView from '@/views/ContactUsView'
import AnnouncementsView from '@/views/AnnouncementsView'
import DocumentsView from '@/views/DocumentsView'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomepageView
    },
    {
        path: '/about',
        name: 'about',
        component: AboutUsView
    },
    {
        path: '/construction',
        name: 'construction',
        component: ConstructionView
    },
    {
        path: '/forestry-land',
        name: 'forestryLand',
        component: ForestryLandView
    },
    {
        path: '/compliance',
        name: 'compliance',
        component: ComplianceView
    },
    {
        path: '/documents',
        name: 'documents',
        component: DocumentsView
    },
    {
        path: '/contact',
        name: 'contact',
        component: ContactUsView
    },
    {
        path: '/faq',
        name: 'faq',
        component: FaqView
    },
    {
        path: '/announcements',
        name: 'announcements',
        component: AnnouncementsView
    },
    {
        path: '/website-terms-conditions',
        name: 'website-terms-conditions',
        component: GdprView
    },
    {
        path: '/:catchAll(.*)',
        component: ErrorView
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router;
